import { render, staticRenderFns } from "./pickingWorkStatus.vue?vue&type=template&id=563cc364&scoped=true&"
import script from "./pickingWorkStatus.vue?vue&type=script&lang=js&"
export * from "./pickingWorkStatus.vue?vue&type=script&lang=js&"
import style0 from "./pickingWorkStatus.vue?vue&type=style&index=0&id=563cc364&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563cc364",
  null
  
)

export default component.exports